export const tr = {
    category: 'Kategoriler',
    selected: 'Seçilenler',
    zones: 'Alanlar'
};
